module.exports = __webpack_public_path__ + "01be6ab4a4b9f39b80d997548bca1edd.svg";